// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const setClaimValidity = (state, action) => action.validity;
const resetClaimValidity = () => getClaimDefaultState().isValidClaim;

export default (state = getClaimDefaultState().isValidClaim, action) => {

    const actionTypes = {
        [actions.COPY_CLAIM_PIP]: resetClaimValidity,
        [actions.UPDATE_CLAIM_PIP_IS_VALID_CLAIM]: setClaimValidity,
        [actions.ADD_CLAIM_PIP_ADDITIONAL_REPAIR]: resetClaimValidity,
        [actions.RESET_CLAIM_PIP]: resetClaimValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/pip/reducers/is-valid-claim.js